import { defineMessages } from 'react-intl';

export default defineMessages({
    standardizeAddressDetails: {
        id: 'common.popup.Standardize.Standardize Address Details',
        defaultMessage: 'Standardize Address Details'
    },
    emailValidationMessage: {
        id: 'common.address.Email.Must be a valid email address',
        defaultMessage: 'Must be a valid email address.',
    },
    ZIPCodeValidationMessage: {
        id: 'common.address.Value must be a valid postal code.',
        defaultMessage: 'Value must be a valid postal code.',
    },
    ZIPCodeValidationMessageTFPA: {
        id: 'common.address.Must be a valid Zip/postal code.',
        defaultMessage: 'Must be a valid Zip Code/Postal Code.',
    },
    phoneValidationMessage: {
        id: 'common.address.PnoneNumber.Must be a valid 10-digit phone number',
        defaultMessage: 'Must be a valid 10-digit phone number.',
    },
    cedexBureauMessage: {
        id: 'common.address.Value must be between 0 and 2 characters',
        defaultMessage: 'Value must be between 0 and 2 characters',
    },
    required: {
        id: 'common.address.This is a required field.',
        defaultMessage: 'This is a required field.',
    },
    TWIAProducerEmailError: {
        id: 'common.address.Producer Email Error',
        defaultMessage: 'This must be the applicant/policyholder email address and must not be one registered with your organization.', // DE16015
    },
    overridden: {
        "id": "common.address.mailing.overridden",
        "defaultMessage": "The address you entered could not be updated to follow USPS standards. You may be contacted for additional information."
    },
    standardized: {
        "id": "common.address.mailing.isStandardized",
        "defaultMessage": "The address you entered has been standardized."
    },
    notStandardized: {
        "id": "common.address.mailing.notStandardized",
        "defaultMessage": "The address you entered has not been standardized."
    },
    nonStandardizedMessage: {
        "id": "common.address.mailing.nonStandardized",
        "defaultMessage": "The address you entered has not been updated to follow USPS standards. You must select Standardize Address to continue."
    },
    standardizedMessage: {
        "id": "common.address.mailing.standardized message",
        "defaultMessage": "The address you entered has been updated to follow USPS standards."
    },
    mortValidationMessage: {  // US26840
        "id": "common.address.mailing.Mort",
        "defaultMessage": "Mortgagee must be added as an Additional Interest in Additional Information Page."
    },
    standardizationErrorMessage: {
        "id": "common.address.mailing.Error",
        "defaultMessage": "There has been a system error, please try again."
    },
    addressLine2: { // DE16425
        "id": "common.address.mailing.addressLine2",
        "defaultMessage": "Address Line 2"
    },
    echeckAddressLine2: {
        "id": "common.address.mailing.Address Line 2 (Apt/Bldg/Suite) ",
        "defaultMessage": "Address Line 2 (Apt/Bldg/Suite)"
    }
})